import { useFeatureFlagEnabled } from "posthog-js/react";

const FEATURE_FLAGS = {
  INVOICE_DETAILS: "invoiceDetails",
  IS_YAPILY_DOWN: "isYapilyDown",
  NO_BACS_LINK: "noBacsLink",
  DISPUTES: "disputes",
  EARLY_SETTLEMENT_DISCOUNT: "earlySettlementDiscount",
};

const useFeatureFlagDevAlwaysEnabled = (flagKey) => {
  const enabled = useFeatureFlagEnabled(flagKey);

  if (typeof window !== "undefined") {
    const host = window.location?.hostname || "";
    if (host.includes("dev") || host.includes("localhost")) {
      return true;
    }
  }

  return enabled;
};

export const useInvoiceDetails = () => {
  return useFeatureFlagDevAlwaysEnabled(FEATURE_FLAGS.INVOICE_DETAILS);
};

export const useIsYapilyDown = () => {
  return useFeatureFlagEnabled(FEATURE_FLAGS.IS_YAPILY_DOWN);
};

export const useNoBacsLink = () => {
  return useFeatureFlagEnabled(FEATURE_FLAGS.NO_BACS_LINK);
};

export const useDisputes = () => {
  return useFeatureFlagDevAlwaysEnabled(FEATURE_FLAGS.DISPUTES);
};

export const useEarlySettlementDiscount = () => {
  return useFeatureFlagDevAlwaysEnabled(FEATURE_FLAGS.EARLY_SETTLEMENT_DISCOUNT);
};
